import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Main } from './pages';
import './common/translations/i18n';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<App></App>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById('root')
);
